import css from "styled-jsx/css";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import Colors from "/styles/colors";
import {
  SEPERATOR_RIGHT_MARGIN,
  SEPERATOR_LEFT_MARGIN,
  SEPERATOR_LEFT_MARGIN_SMALL,
  SEPERATOR_RIGHT_MARGIN_SMALL
} from "./constants";
import { HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH } from "/constants/vp-sizes";

const SEPERATOR_RIGHT_MARGIN_PX = `${SEPERATOR_RIGHT_MARGIN}px`;
const SEPERATOR_RIGHT_MARGIN_SMALL_PX = `${SEPERATOR_RIGHT_MARGIN_SMALL}px`;
const SEPERATOR_LEFT_MARGIN_PX = `${SEPERATOR_LEFT_MARGIN}px`;
const SEPERATOR_LEFT_MARGIN_SMALL_PX = `${SEPERATOR_LEFT_MARGIN_SMALL}px`;

export const componentStyles = css.global`
  .sections-header-menu-component {
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    padding: 24px 0;

    .header-menu-sections-wrapper {
      max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
      width: 100%;
      height: 100%;
      display: flex;
      margin: auto;
      padding: 0px 32px;
      .sections-separator {
        border-right: 1px solid;
        border-color: ${Colors["border-gray"]};
        margin-right: ${SEPERATOR_RIGHT_MARGIN_PX};
        margin-left: ${SEPERATOR_LEFT_MARGIN_PX};
      }
    }
  }

  @media (max-width: ${HEADER_DESKTOP_MENU_NARROW_SCREEN_MAX_WIDTH}) {
    .sections-header-menu-component {
      .header-menu-sections-wrapper {
        .sections-separator {
          margin-right: ${SEPERATOR_RIGHT_MARGIN_SMALL_PX};
          margin-left: ${SEPERATOR_LEFT_MARGIN_SMALL_PX};
        }
      }
    }
  }
`;
